import { Grid, Typography, Box } from "@mui/material";
import Input from "../../../components/inputs/input";
import { cashTypes, cashTypesFormat } from "../../../models/CashRegisterMovementEntity";
import VisibilityIcon from '@mui/icons-material/Visibility';
import IconButton from '@mui/material/IconButton';
import { utils } from "../../../utils/utils";

const Total = ({ cashType, totals, detail, onInputChange, viewMovements, diff }) => {
    const isCashType = () =>
        cashType !== cashTypes.cash &&
        cashType !== cashTypes.check &&
        cashType !== cashTypes.link &&
        cashType !== cashTypes.qr &&
        cashType !== cashTypes.transfer &&
        cashType !== cashTypes.terminalQr
    return (
        <Grid container spacing={1} alignItems="center">
            <Grid size={2}>
                <Typography color='primary' variant='subtitle1' component='p' style={{ textTransform: 'uppercase' }}>
                    <strong>{cashTypesFormat[cashType]}:</strong>
                </Typography>
            </Grid>
            <Grid size="grow">
                <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
                    {isCashType() &&
                        totals[cashType] &&
                        totals[cashType].price > 0 &&
                        <Grid size='grow'>
                            <Typography variant='body1' align="right">
                                {utils.formatMoney(totals[cashType].price)}
                            </Typography>
                        </Grid>
                    }
                    {isCashType() &&
                        totals[cashType] &&
                        totals[cashType].lastClosureAmount >= 0 &&
                        <Grid size="grow">
                            <Typography variant='body1' align="right">
                                {utils.formatMoney(totals[cashType].lastClosureAmount)}
                            </Typography>
                        </Grid>
                    }
                    <Grid size="grow">
                        <Typography variant='body1' align="right">
                            {utils.formatMoney(totals[cashType] ? totals[cashType].ingress : 0)}
                        </Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography variant='body1' align="right">
                            {utils.formatMoney(totals[cashType] ? totals[cashType].egress : 0)}
                        </Typography>
                    </Grid>
                    <Grid size="grow">
                        <Typography variant='body1' align="right">
                            {utils.formatMoney(totals[cashType] ? totals[cashType].total : 0)}
                        </Typography>
                    </Grid>
                    {
                        diff &&
                        <Grid size="grow">
                            <Typography variant='body1' align="right">
                                {utils.formatMoney(totals[cashType] ? (detail[cashType]?.real || 0) - totals[cashType].total : 0)}
                            </Typography>
                        </Grid>
                    }
                    <Box component={Grid} item size={2} display='flex' justifyContent='flex-end'>
                        <Input
                            required
                            size='small'
                            key={`${cashType}`}
                            name={`${cashType}`}
                            label={`Real ${cashTypesFormat[cashType]}`}
                            onChange={onInputChange}
                            value={detail[cashType]?.real >= 0 ? detail[cashType]?.real : ''}
                        />
                    </Box>
                </Grid>
            </Grid>
            {
                viewMovements &&
                <Box component={Grid} item size={1} display='flex' justifyContent='flex-end'>
                    <IconButton onClick={viewMovements} size="large">
                        <VisibilityIcon />
                    </IconButton>
                </Box>
            }
        </Grid>
    );
}
export default Total;